import React from "react";
import { Moon, Sun } from "lucide-react"; // Import icons
import { NavLink } from "react-router-dom";
import buymeacoffee from "./../images/buymeacoffee.png";

const Header = ({ currentTheme, toggleTheme }) => {
  return (
    <header
      className="py-4 shadow-lg min-h-[8vh] border-b"
      style={{
        backgroundColor: "var(--md-sys-color-surface-container)",
        borderColor: "var(--md-sys-color-outline-variant)",
      }}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <NavLink to="/" className="group">
          <h1
            className="text-xl font-bold tracking-wide transition-transform duration-300 group-hover:scale-105"
            style={{ color: "var(--md-sys-color-on-surface)" }}
          >
            <span
              className="inline-block"
              style={{ color: "var(--md-sys-color-primary)" }}
            >
              Anime
            </span>{" "}
            Opening Quiz
          </h1>
        </NavLink>
        <div className="flex items-center gap-4">
          <button
            onClick={toggleTheme}
            className="p-2.5 rounded-full transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--md-sys-color-primary)] shadow-md hover:shadow-lg"
            style={{
              backgroundColor: "var(--md-sys-color-primary-container)",
              color: "var(--md-sys-color-on-primary-container)",
            }}
            aria-label={
              currentTheme === "light"
                ? "Switch to dark mode"
                : "Switch to light mode"
            }
          >
            {currentTheme === "light" ? (
              <Moon
                size={22}
                className="transition-transform duration-300 hover:rotate-12"
              />
            ) : (
              <Sun
                size={22}
                className="transition-transform duration-300 hover:rotate-45"
              />
            )}
          </button>
          <a href="https://buymeacoffee.com/kevaunjhc">
            <img src={buymeacoffee} className=" w-9 h-9 rounded-full"></img>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
